export default __webpack_public_path__ + "static/asleepFearful-1440a362c44ebbacc2377469d36b3486.svg";